import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/hooks/useAuth';
import { AUTH_MESSAGES } from '../../constants/authMessages';
import './ProtectedRoute.css';

/**
 * ProtectedRoute - 인증 보호 라우트 컴포넌트
 *
 * 미인증 사용자를 로그인 페이지로 리다이렉트하고, 역할 기반 접근 제어를 수행한다.
 */
export function ProtectedRoute({ allowedRoles, redirectTo = '/login' }) {
  const { user, loading, isAuthenticated, hasRole } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-spinner"></div>
        <p>{AUTH_MESSAGES.SESSION_CHECKING}</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    // Save the attempted location for redirect after login
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Check role-based access if allowedRoles specified
  if (allowedRoles && allowedRoles.length > 0) {
    if (!hasRole(allowedRoles)) {
      // User is authenticated but doesn't have required role
      return (
        <div className="protected-route-unauthorized">
          <div className="unauthorized-content">
            <div className="unauthorized-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h2>{AUTH_MESSAGES.ERROR_UNAUTHORIZED}</h2>
            <p>현재 계정({user?.role})으로는 이 페이지에 접근할 수 없습니다.</p>
            <button className="ds-button ds-button-primary" onClick={() => window.history.back()}>
              이전 페이지로 돌아가기
            </button>
          </div>
        </div>
      );
    }
  }

  // Render child routes
  return <Outlet />;
}

export default ProtectedRoute;
